import merge from 'lodash.merge';
import set from 'lodash.set';
const reducer = (state, action) => {
    const newState = {};
    const resolveAction = (action) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        newState[action.type] = action.payload;
        if (action.type === 'initial') {
            set(state, 'results', action.payload);
        }
    };
    if (Array.isArray(action)) {
        action.forEach(resolveAction);
    }
    else {
        resolveAction(action);
    }
    return merge({}, merge(state, newState));
};
export default reducer;
